/**
 * Navigation helper for test-safe URL navigation
 * Uses window.location.assign() instead of window.location.href
 * to avoid jsdom "Not implemented: navigation" errors in tests
 */
export const navigateTo = (url: string): void => {
  window.location.assign(url)
}


